/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#app-cmp .version{position:absolute;bottom:0;right:0;color:transparent;font-size:small;-webkit-user-select:all;-moz-user-select:all;-ms-user-select:all;user-select:all}#app-cmp .ui-toast-detail{word-break:break-word;margin-left:-2em}#app-cmp a.ui-toast-close-icon:hover{text-decoration:none}#app-cmp a#errorCopy{color:gray}#app-cmp .as-split-area.flex-extra{flex:1 1 auto}"];
export { styles as styles };
